
import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const AktiverVerkehrIcon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M19.9993 13.334H139.999C147.333 13.334 153.333 19.334 153.333 26.6673V106.667C153.333 114.001 147.333 120.001 139.999 120.001H93.3327V133.334H106.666V146.667H53.3327V133.334H66.666V120.001H19.9993C12.666 120.001 6.66602 114.001 6.66602 106.667V26.6673C6.66602 19.334 12.666 13.334 19.9993 13.334ZM19.9993 106.667H139.999V26.6673H19.9993V106.667Z" fill={color} fillOpacity="0.8" />
        <path d="M97.9 39L107.862 48.9615L86.6335 70.1895L69.2335 52.7895L37 85.0665L43.1335 91.2L69.2335 65.1L86.6335 82.5L114.038 55.1385L124 65.1V39H97.9Z" fill={color} fillOpacity="0.8" />
    </svg>
);

export default AktiverVerkehrIcon;
